import banners from "./banners";
import boards from "./boards";
import center from "./center";
import fairs from "./fairs";
import forms from "./forms";
import me from "./me";
import message from "./message";
import popups from "./popups";
import rental from "./rental";
import setting from "./setting";
import shop from "./shop";
import terms from "./terms";
import users from "./users";

export default {
    banners,
    boards,
    center,
    fairs,
    forms,
    me,
    message,
    popups,
    rental,
    setting,
    shop,
    terms,
    users,
};
